export const API_HEADERS = Object.freeze({
  AVS_SESSION_ID: "x-avs-sessionid",
  AVS_TRANSACTION_ID: "x-avs-transactionid",
  AVS_ERROR_DESCRIPTION: "x-avs-error-description",
  ACCESS_TYPE: "x-access-type",
  SERVICE_PROVIDER: "x-service-provider",
  LINE_TYPE: "x-line-type",
  AVS_RESULT_CODE: "x-avs-result-code",
});
